export const BUTTON_MIN_WIDTH = 128;
export const BUTTON_MIN_HEIGHT = 40;
